import React, { useState } from 'react'
import { Grid, Form, Segment, Button, Header, Icon, Label } from 'semantic-ui-react'
import { Form as FinalForm, Field } from 'react-final-form'
import { combineValidators, isRequired, composeValidators, hasLengthGreaterThan, hasLengthBetween, isNumeric, isOneOf, createValidator, hasLengthLessThan } from 'revalidate'
import TextInput from '../../../app/common/form/TextInput';
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import HeaderSubHeader from 'semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader'
import CheckboxInput from '../../../app/common/form/CheckboxInput';
import SelectInput from '../../../app/common/form/SelectInput';
import ContactabilidadService from '../../../app/api/contactabilidadService';
import RadioInput from '../../../app/common/form/RadioInput';
import RCG from 'react-captcha-generator';
import { cuotasAdicionalesOptions } from '../../../app/config/data/options';



const ReprogramarForm = ({ history }) => {

    const [submitting, setSubmitting] = useState(false);
    const [captcha, setCaptcha] = useState(null);
    const [sizeTipoDocumento, setSizeTipoDocumento] = useState(8);

    const handleFinalFormSubmit = async (values) => {
        const { ...reprogramacion } = values;
        if (reprogramacion.confirmacion === true) {
            reprogramacion.confirmacion = 1;
        }
        setSubmitting(true)
        try {
            await ContactabilidadService.create(reprogramacion);
            setSubmitting(false)
            history.push('/')
            toast.success('La reprogramación fue enviada correctamente.')
        } catch (error) {
            setSubmitting(false)
            toast.error('Hubo problemas al enviar la reprogramación.')
        }

    }

    const isValidEmail = createValidator(
        message => value => {
            if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
                return message
            }
        },
        'Email inválido.'
    );

    const isValidCaptcha = createValidator(
        message => value => {
            if (value !== captcha) {
                return message
            }
        },
        'Captcha no válido.'
    );

    const isValidNumeroDocumento = createValidator(
        message => (...values) => {
            if (values && values.length > 1) {
                if (values[1]['tipoDocumento'] && values[1]['tipoDocumento'] === '1'
                    && values[0] && values[0].length !== 8) {

                    return message

                }
                if (values[1]['tipoDocumento'] && values[1]['tipoDocumento'] === '2'
                    && values[0] && values[0].length !== 9) {
                    return message

                }
            }
        },
        'Numero de documento inválido.'
    );

    const onChangeTipoDocumento = createValidator(
        message => value => {
            if (value) {
                value === '1' ? setSizeTipoDocumento(8) : setSizeTipoDocumento(9);
            }
        },
        'Tipo documento no válido.'
    );

    const validate = combineValidators({
        tipoDocumento: composeValidators(
            onChangeTipoDocumento,
            isRequired({ message: 'Tipo de documento es requerido.' }),
            isNumeric({ message: 'Seleccione un documento válido.' }),
            hasLengthBetween(1, 2)({
                message: 'Seleccione un tipo de documento válido.'
            })
        )(),
        numeroDocumento: composeValidators(
            isRequired({ message: 'Número de documento es requerido.' }),
            isNumeric({ message: 'Ingrese un documento válido.' }),
            isValidNumeroDocumento('tipoDocumento')
        )(),
        nombresApellidos: composeValidators(
            isRequired({ message: 'Nombres y apellidos es requerido.' }),
            hasLengthLessThan(200)({
                message: 'Nombres y apellidos inválido.'
            })
        )(),
        celular: composeValidators(
            isRequired({ message: 'Celular es requerido.' }),
            isNumeric({ message: 'Ingrese solo números.' }),
            hasLengthBetween(9, 9)({
                message: 'Ingrese un celular válido.'
            })
        )(),
        telefono: composeValidators(
            isNumeric({ message: 'Ingrese solo números.' }),
            hasLengthBetween(7, 9)({
                message: 'Ingrese un teléfono válido.'
            })
        )(),
        actividad: composeValidators(
            isRequired({ message: 'Actividad es requerido.' }),
            hasLengthGreaterThan(3)({
                message: 'Ingrese al menos 4 caracteres.'
            }),
            hasLengthLessThan(200)({
                message: 'Actividad inválido.'
            })
        )(),
        correo: composeValidators(
            isRequired({ message: 'Correo es requerido.' }),
            isValidEmail,
            hasLengthLessThan(200)({
                message: 'Correo inválido.'
            })
        )(),
        credito: composeValidators(
            isNumeric({ message: 'Ingrese un crédito válido.' }),
            hasLengthBetween(10, 10)({
                message: 'Ingrese un crédito válido.'
            })
        )(),
        prorroga: composeValidators(
            isRequired({ message: 'Debe de elegir una opción.' }),
            isOneOf(["1", "2", "3"]))({
                message: 'Prorroga no válido.'
            }),
        confirmacion: composeValidators(
            isRequired({ message: 'Debe de confirmar los datos.' }),
            isOneOf([true]))({ message: 'Debe de confirmar los datos.' }),
        captcha: composeValidators(
            isRequired({ message: 'Debe de ingresar el captcha.' }),
            isValidCaptcha
        )(),
        cuotasAdicionales: composeValidators(
            isNumeric({ message: 'Cuotas adicionales inválida.' }),
            hasLengthBetween(0, 12))({
                message: 'Cuotas adicionales inválida.'
            }),
    });

    const normalizeLetrasEspacios = value => {
        if (!value) return value;
        return value.replace(/[^A-Za-z ñÑ]+/g, "");
    };

    const normalizeNumero = value => {
        if (!value) return value;
        return value.replace(/[^\d]/g, "");
    };

    return <Grid>
        <Grid.Column width={16}>
            <Segment clearing>
                <FinalForm onSubmit={handleFinalFormSubmit}
                    validate={validate}
                    initialValues={{
                        tipoDocumento: '1',
                        prorroga: '2',
                        cuotasAdicionales: '0'
                    }}
                    render={({ handleSubmit, invalid, pristine }) =>
                        <Form onSubmit={handleSubmit}>
                            <Header size='medium' icon textAlign='center'>
                                <Icon name='calendar check' color="blue" />
                                <Header.Content>Solicita aquí tu reprogramación</Header.Content>
                            </Header>
                            <Header textAlign='center'>
                                <HeaderSubHeader>
                                    Por favor completa esta solicitud.<br /><br />
                                    Recuerda que esta reprogramación no cambiara tu historial de buen pagador.
                                    <br />
                                    (*) Campos Obligatorios
                                </HeaderSubHeader>
                            </Header>
                            <br />
                            <Field name="tipoDocumento" component={SelectInput} values={
                                [
                                    {
                                        value: "",
                                        text: "Tipo de Documento"
                                    }, {
                                        value: "1",
                                        text: "D.N.I"
                                    }, {
                                        value: "2",
                                        text: "Carnet de Extranjería"
                                    }
                                ]
                            } />
                            <br />
                            <Field placeholder="Número de Documento de Identidad (*)" name="numeroDocumento"
                                component={TextInput} maxLenght={sizeTipoDocumento}
                                parse={normalizeNumero} />
                            <br />
                            <Field placeholder="Nombres y Apellidos (*)" name="nombresApellidos" component={TextInput}
                                parse={normalizeLetrasEspacios} maxLenght="200" />
                            <br />
                            <Field placeholder="Celular (*)" name="celular" component={TextInput} maxLenght="9"
                                parse={normalizeNumero}
                            />
                            <br />
                            <Field placeholder="Teléfono" name="telefono" component={TextInput} maxLenght="7"
                                parse={normalizeNumero}
                            />
                            <br />
                            <Field placeholder="Correo electrónico (*)" name="correo" component={TextInput} maxLenght="100" />
                            <br />
                            <Field placeholder="Número de crédito" name="credito" component={TextInput} maxLenght="10"
                                parse={normalizeNumero} />
                            <br />
                            <Field placeholder="Actividad que realizas (*)" name="actividad" component={TextInput}
                                maxLenght="200" parse={normalizeLetrasEspacios} />
                            <br />
                            <HeaderSubHeader style={{ color: 'gray' }}>
                                Prorrogar mi pago por:
                            </HeaderSubHeader>
                            <br />
                            <Field type="radio" name="prorroga" value="1" component={RadioInput}
                                label='30 días.' />
                            <Field type="radio" name="prorroga" value="2" component={RadioInput}
                                label='60 días. ' />
                            {/* <Field type="radio" name="prorroga" value="3" component={RadioInput}
                                label='90 días.' /> */}
                            <br />
                            <HeaderSubHeader style={{ color: 'gray' }}>
                                ¿Desea ampliar el cronograma de su crédito?
                                <br />
                                <br />
                                <em>(Le permitirá reducir el monto de sus próximas cuotas para poder afrontar la situación actual.)</em>
                                <br />
                                <br />
                            </HeaderSubHeader>
                            <Field name="cuotasAdicionales" component={SelectInput} values={cuotasAdicionalesOptions} />
                            <Label as='a' color='blue' tag size="medium">
                                El proceso de reprogramación es sujeto a evaluación.
                            </Label>
                            <Header textAlign='justified'>
                                <HeaderSubHeader>
                                    Estimado cliente por favor tener en cuenta el día de pago de su próxima
                                    cuota, por la situación actual situación del estado de emergencia considere
                                    tener el máximo tiempo de recuperación. Esto incluye además las cuotas
                                    extras que necesite.
                                </HeaderSubHeader>
                            </Header>
                            <Field type="checkbox" name="confirmacion" component={CheckboxInput}
                                label='Confirmo que la información ingresada es correcta y veraz.' />
                            <Header textAlign='justified'>
                                <HeaderSubHeader style={{ color: 'gray' }}>
                                    Declaro que tengo conocimiento que mi nuevo cronograma de pago estará
                                    disponible en las oficinas de Prymera.
                                </HeaderSubHeader>
                                <br />
                                <HeaderSubHeader style={{ color: 'gray' }}>
                                    Al enviarnos esta información usted autoriza a Prymera el tratamiento de
                                    sus datos personales. Conoce más <a href="https://prymera.pe/transparencia" target="_blank" rel="noopener noreferrer">aqui</a>
                                </HeaderSubHeader>
                            </Header>
                            <Grid style={{ marginLeft: 5 }}>
                                <RCG
                                    result={(value) =>
                                        setCaptcha(value)
                                    }

                                />
                            </Grid>
                            <Field placeholder="Captcha" name="captcha" component={TextInput} />

                            <Button
                                disabled={invalid || pristine}
                                floated="right"
                                primary
                                type="submit"
                                content="Enviar"
                                loading={submitting}
                            />
                            {/* <Button
                                floated="right"
                                color="grey"
                                type="button"
                                content="Cancel"
                                onClick={
                                    () => history.push('/')
                                }
                            /> */}

                        </Form>}>

                </FinalForm>
            </Segment>
        </Grid.Column>
    </Grid>;
}

ReprogramarForm.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
}
export default ReprogramarForm
